import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';

import { getCsrf, getUserData, noUserLoggedIn, setIsLogged } from '../../store/ducks/auth';
import Login from '../../pages/Login';

const CheckAuthentication = ({ children }) => {
  const { csrf, userLoggedIn, isAdmin, fetched } = useSelector(state => state.auth);
  const [cookies, setCookie, removeCookie] = useCookies();

  const dispatch = useDispatch();

  useEffect(() => {
    if (!csrf) dispatch(getCsrf());
  }, []);

  useEffect(() => {
    if (cookies.if) dispatch(setIsLogged(true));
    else dispatch(noUserLoggedIn());
  }, [cookies]);

  useEffect(() => {
    if (userLoggedIn) dispatch(getUserData());
  }, [userLoggedIn]);

  if (csrf && fetched && !userLoggedIn) return <Login />;
  if (csrf && isAdmin) return children;
  return <></>;
};

export default CheckAuthentication;
